const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

document.querySelectorAll('.events-module__item').forEach((item) => {
  const image = item.querySelector('.events-module__item-image');
  let mouseX;
  let mouseY;

  const moveImage = (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    image.style.left = `${mouseX}px`;
    image.style.top = `${mouseY}px`;
  };

  const handleMouseEnter = (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    image.style.display = 'block';

    document.addEventListener('mousemove', moveImage);

    const handleMouseLeave = () => {
      image.style.display = 'none';
      document.removeEventListener('mousemove', moveImage);
      item.removeEventListener('mouseleave', handleMouseLeave);
    };

    item.addEventListener('mouseleave', handleMouseLeave);
  };

  if (image && !isTouchDevice()) {
    item.addEventListener('mouseenter', handleMouseEnter);
  }
});

attachEvent('.is-archive .events-module__title', 'click', (el) => {
  const parentElem = el.target.closest('.events-module__event-list');
  parentElem.classList.toggle('is-open');
  const content = parentElem.querySelector('.events-module__event-content');
  slideToggle(content, 300, 'block');
});
